// External Libraries
import { useImmerReducer } from "use-immer";
import { v4 } from "uuid";

// Internal Utilities
import { deepCopy } from "../../../../helper";

export const UPDATE_MAILING_LIST_TITLE = "UPDATE_MAILING_LIST_TITLE";
export const UPDATE_MAILING_LIST_COLOR_CODE = "UPDATE_MAILING_LIST_COLOR_CODE";
export const ADD_USER_TO_MAILING_LIST = "ADD_USER_TO_MAILING_LIST";
export const UPDATE_USER_IN_MAILING_LIST = "UPDATE_USER_IN_MAILING_LIST";
export const REMOVE_USER_FROM_MAILING_LIST = "REMOVE_USER_FROM_MAILING_LIST";
export const ADD_USERS_IN_BULK = "ADD_USERS_IN_BULK";
export const ADD_USERS_AT_ONCE = "ADD_USERS_AT_ONCE";
export const ADD_USERS_AT_ONCE_FOR_INITIAL_STATE =
  "ADD_USERS_AT_ONCE_FOR_INITIAL_STATE";
export const RESET_MAILING_LIST_FORM = "RESET_MAILING_LIST_FORM";
export const SET_MAILING_LIST_STATE_FROM_PAYLOAD =
  "SET_MAILING_LIST_STATE_FROM_PAYLOAD";

const initialMailingListState = {
  mailingListId: v4(),
  mailingListTitle: "",
  colorCode: { id: 5, value: "5", label: "Primary", colorCode: "#6366F1" },
  users: [],
  initialMailingListStateForEdit: {},
};

const mailingListReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_MAILING_LIST_TITLE:
      state.mailingListTitle = action.payload;
      break;
    case UPDATE_MAILING_LIST_COLOR_CODE:
      state.colorCode = action.payload;
      break;
    case ADD_USER_TO_MAILING_LIST:
      state.users.push(action.payload);
      break;
    case UPDATE_USER_IN_MAILING_LIST:
      const userIndex = state.users.findIndex(
        (user) => user.email === action.payload.email
      );
      if (userIndex !== -1) {
        state.users[userIndex] = {
          ...state.users[userIndex],
          ...action.payload,
        };
      }
      break;
    case REMOVE_USER_FROM_MAILING_LIST:
      state.users = state.users.filter((user) => user.email !== action.payload);
      break;
    case ADD_USERS_IN_BULK:
      state.users.push(...action.payload);
      break;
    case ADD_USERS_AT_ONCE:
      state.users = action.payload;
      break;
    case RESET_MAILING_LIST_FORM:
      return deepCopy(initialMailingListState);
    case ADD_USERS_AT_ONCE_FOR_INITIAL_STATE:
      state["initialMailingListStateForEdit"]["users"] = action.payload;
      break;
    case SET_MAILING_LIST_STATE_FROM_PAYLOAD:
      return action.payload;
    default:
      // No changes needed here
      break;
  }
};

const useMailingListForm = () => {
  const [mailingListState, dispatch] = useImmerReducer(
    mailingListReducer,
    deepCopy(initialMailingListState)
  );

  const onChange = (type, payload) => {
    dispatch({ type, payload });
  };

  return { mailingListState, onChange };
};

export default useMailingListForm;
